import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import ToDoItem from './to-do-item';
import ToDoItemDetail from './to-do-item-detail';
import ToDoItemUpdate from './to-do-item-update';
import ToDoItemDeleteDialog from './to-do-item-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={ToDoItemUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={ToDoItemUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={ToDoItemDetail} />
      <ErrorBoundaryRoute path={match.url} component={ToDoItem} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={ToDoItemDeleteDialog} />
  </>
);

export default Routes;
